module.exports = __webpack_public_path__ + "static/media/creativ12.949e9c4e.jpg";